import * as React from 'react';

import OptionalCardDetail from 'components/molecules/Card/Detail/Optional';
import { OptionalCardPropsType } from 'components/molecules/OptionalCard';
import { CardTypes } from 'defs/card-types';
import { OPTIONAL_ITEM_TYPES } from 'store/optionalProgramItems';
// import { CardTypeTypes } from 'types/Card'; FIXME: index

const getComponentMap: () => {
	[key: string]: (props: any) => React.ReactNode;
} = () => ({
	[CardTypes.Recipe]: (props: any): React.ReactNode => (
		<OptionalCardDetail type={OPTIONAL_ITEM_TYPES.RECIPE} {...props} />
	),
	[CardTypes.Workout]: (props: any): React.ReactNode => (
		<OptionalCardDetail type={OPTIONAL_ITEM_TYPES.WORKOUT} {...props} />
	),
});

export const CardDetail = (props: OptionalCardPropsType | any) => {
	if (!props.type) {
		return null;
	}
	return getComponentMap()[props.type](props);
};

CardDetail.displayName = 'OptionalCard(Detail)';

export default CardDetail;
